export const CardExpirationFilter = angular
    .module('checkout.filters.ccExpiration', [])
    .filter('ccExpiration', () => {
        return (expry, key) => {
            if (expry === null || expry === undefined) return '';
            const plainNumber = expry.replace(/[^\d]+/g, '');
            switch (true) {
                case plainNumber.length <= 1 || (key === 8 && plainNumber.length === 2):
                    return `${plainNumber}`;
                case plainNumber.length === 2 && key !== 8:
                    return `${plainNumber} / `;
                case plainNumber.length >= 3:
                    return `${plainNumber.slice(0, 2)} / ${plainNumber.slice(2, 6)}`;
                default:
                    return plainNumber;
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/filters/cardExpiration.js